/*****************
 2019-2-13, AJK, added update record call
 2019-2-13, AJK, added change password function
 2019-2-18, AJK, added create user function
******************/


import axios from 'axios';


export default {
    find: function(query) {
        return axios.post(`proxy.php?/layouts/wholesaler-lookup/_find`, query)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`;
            }
        })
    },
    
    updateRecord: function(fieldData, recordID) {
        return axios.patch(`proxy.php?/layouts/wholesaler-lookup/records/${recordID}`, fieldData)
        .then((response)=>{
            return response.data
        })
        .catch((e)=>{
            if(e.response.data.messages[0].message){
                //Return FM Error Response
                return e.response.data
            }
            else{
                //Format Unknown Error Like a FM Error
                return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
            }
        })
    },
    
    // createUser: function(fieldData){
    //     return axios.post(`proxy.php?/layouts/user-login/records`, fieldData)
    //     .then((response)=>{
    //         return response.data
    //     })
    //     .catch((e)=>{
    //         if(e.response.data.messages[0].message){
    //             //Return FM Error Response
    //             return e.response.data
    //         }
    //         else{
    //             //Format Unknown Error Like a FM Error
    //             return  `{ messages:[message: ${e.message}, code: -1],response: {}}`
    //         }
    //     })
    // }
}